package com.castly.shared.dto

import kotlinx.serialization.Serializable

@Serializable
data class AdminEpisodeDetailDto(
    val id: String,
    val audiobookIsbn: String,
    val episodeNumber: Int? = null,
    val title: String,
    val description: String? = null,
    val durationSeconds: Int? = null,
    val audioUrl: String? = null,
    val imageUrl: String? = null,
    val status: String,
    val deletedAt: String? = null,
    val createdAt: String,
    val updatedAt: String,
    val translations: Map<String, EpisodeTranslationDto> = emptyMap()
)
